<div class="flex items-center justify-center h-full">
  <div class="flex w-full md:w-1/3 mt-20 items-center p-10 justify-center text-center">
    <activar-card>
      <div class="flex items-center justify-center">
        <activar-icon name="success" size="80px" class="mb-5" />
      </div>

      <h2>Inspección cargada correctamente</h2>
      <p>
        Nuestro equipo la estará revisando en un plazo de hasta 5 días hábiles.
      </p>

      <div class="flex flex-col gap-2 mt-5" *showForChannels="['agents']">
        <activar-button
          color="primary"
          text="Volver al inicio"
          expand="full"
          fill="out"
          [routerLink]="quoterRoutePath"
        />

        <activar-button
          color="primary"
          text="Ver Inspección"
          expand="full"
          (click)="viewInspection()"
        />
      </div>
    </activar-card>
  </div>
</div>
